/**
 * PURPOSE: Cancha principal compacta, siempre lado a lado en celular.
 * ROUTE: src/pages/VolleyballViewer/components/ViewerCourt.jsx
 */

import ViewerTeamCourt from "./ViewerTeamCourt.jsx";

export default function ViewerCourt({ payload, swapped }) {
  const teams = payload?.teams || {};
  const court = payload?.court || { A: [], B: [] };
  const leftCode = swapped ? "B" : "A";
  const rightCode = swapped ? "A" : "B";
  const playersFor = (code) => {
    const value = court?.[code];
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.positions)) return value.positions;
    return [];
  };
  const leftTeam = { ...(teams[leftCode] || {}), teamCode: leftCode };
  const rightTeam = { ...(teams[rightCode] || {}), teamCode: rightCode };

  return (
    <section className="flex min-h-0 flex-1 overflow-hidden rounded-2xl border border-slate-200 bg-white p-1.5 shadow-sm">
      <div className="grid min-h-0 flex-1 grid-cols-[minmax(0,1fr)_2px_minmax(0,1fr)] gap-1.5">
        <ViewerTeamCourt team={leftTeam} players={playersFor(leftCode)} side="left" servingTeam={payload?.currentSet?.servingTeam || payload?.servingTeam} />
        <div className="min-h-0 rounded-full bg-slate-900 shadow-sm" aria-hidden="true" />
        <ViewerTeamCourt team={rightTeam} players={playersFor(rightCode)} side="right" servingTeam={payload?.currentSet?.servingTeam || payload?.servingTeam} />
      </div>
    </section>
  );
}
